import ReportClasses from './report_classes';
import TypeReflect from 'models/lib/type_reflect';

export const typeReflect = new TypeReflect(ReportClasses);

export default function(report) {
  let ReportClass = typeReflect.typeToConstructor(report.type);
  return ReportClass.fromJs(report);
}
